import { getCurrentUrl } from '../services/ApiServices';

export const unauthorizedEventName = 'dashboard:unauthorized';

const clearSession = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('user');
	window.dispatchEvent(new Event(unauthorizedEventName));
};

async function getResponseData<IResponse>(response: Response): Promise<IResponse | any> {
	const text = await response.text();
	if (!text) return null;

	try {
		return JSON.parse(text);
	} catch {
		return text;
	}
}

const getErrorMessage = (data: any): string => {
	if (typeof data === 'string') return data;
	return data?.message || data?.error || 'Une erreur est survenue lors de la récupération des données.';
};

// Make the `request` function generic
// to specify the return data type:
export async function request<IResponse>(
	url: string,
	// `RequestInit` is a type for configuring
	// a `fetch` request. By default, an empty object.
	config: RequestInit = {}

	// This function is async, it will return a Promise:
): Promise<IResponse> {
	// Inside, we call the `fetch` function with
	// a URL and config given:
	const fullUrl = getCurrentUrl() + url;
	const headers = new Headers(config.headers);
	headers.set('Authorization', `JWT ${localStorage.getItem('token')}`);
	const requestOption = { ...config, headers };
	const response = await fetch(fullUrl, requestOption);
	const data = await getResponseData<IResponse>(response);

	if (response.status === 401) {
		clearSession();
		throw new Error('Votre session a expiré. Veuillez vous reconnecter.');
	}

	if (!response.ok) {
		throw new Error(getErrorMessage(data));
	}

	return data?.rows || (data as IResponse);

	// We also can use some post-response
	// data-transformations in the last `then` clause.
}
